import clsx from 'clsx'
import React, { FC, SVGProps } from 'react'

import { CustomIconProps } from '@/shared/ui/icon-template'

import cl from './DeliveryPayGrid.module.scss'

export type DeliveryPayItemProps = {
	title: string
	description: string
	icons: React.FC<SVGProps<SVGSVGElement> & CustomIconProps>[]
}

export type DeliveryPayGridProps = {
	items: DeliveryPayItemProps[]
}

export const DeliveryPayGrid: FC<DeliveryPayGridProps> = ({ items }) => {
	const classes = clsx(cl.deliveryPay__list, {
		[cl.one_item]: items.length === 1
	})
	return (
		<ul className={classes}>
			{items.map(item => (
				<li key={item.title} className={cl.deliveryPay__item}>
					<div className={cl.deliveryPay__textWrapper}>
						<h3 className={cl.deliveryPay__title}>{item.title}</h3>
						<p className={cl.deliveryPay__subtitle}>{item.description}</p>
					</div>
					<div className={cl.deliveryPay__iconsWrapper}>
						{item.icons.map((ItemComponent, index) => (
							<ItemComponent key={index} className={cl.deliveryPay__icon} />
						))}
					</div>
				</li>
			))}
		</ul>
	)
}
